// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"2daf80a0","2550":"7b745176","4248":"34a7cd5d","6488":"93f427e4","8474":"a1f6b74d","8672":"6d5cd6c9","9398":"6cd955f2","9545":"3d321ff6","9721":"af924a35"}[chunkId] + ".chunk.css";
};